import React from "react";
import { Box, IconButton, Typography, useTheme } from "@mui/material";
import { User, X } from "lucide-react";
import { ENTITY_ICON } from "../../entityIcons";
import { CatalogEntityType } from "../../types";

interface ProgressModalHeaderProps {
  title: string;
  userName?: string;
  objectTitle?: string;
  objectType: CatalogEntityType;
  onClose: () => void;
}

const ProgressModalHeader: React.FC<ProgressModalHeaderProps> = ({
  title,
  userName,
  objectTitle,
  objectType,
  onClose,
}) => {
  const theme = useTheme();
  const contextSx = { fontSize: "14px", fontWeight: 600 };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
        gap: 2,
        color: theme.palette.text.primary,
      }}
    >
      <Box sx={{ minWidth: 0 }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            flexWrap: "wrap",
            "& svg": { width: 16, height: 16 },
          }}
        >
          <User />
          <Typography sx={contextSx}>{userName || "-"}</Typography>
          {objectTitle && (
            <>
              <Typography sx={{ ...contextSx, color: theme.palette.divider }}>
                |
              </Typography>
              {ENTITY_ICON[objectType]}
              <Typography sx={contextSx}>{objectTitle}</Typography>
            </>
          )}
        </Box>
        <Typography sx={{ fontSize: "20px", fontWeight: 700, mt: 0.5 }}>
          {title}
        </Typography>
      </Box>
      <IconButton
        onClick={onClose}
        aria-label="close"
        sx={{ color: theme.palette.text.primary }}
      >
        <X size={20} />
      </IconButton>
    </Box>
  );
};

export default ProgressModalHeader;
